export const isIE9 = testIsIE9()
export const isIE10 = testIsIE10()
export const isIE11 = testIsIE11()

function testIsIE9 () {
  // Issue: Depends on IE conditional comments being present
  if(document.getElementsByTagName('html')[0].classList.contains('lt-ie10')){
    return true
  }
  else
  {
    return false
  }
}

function testIsIE10 () {
  // From https://stackoverflow.com/questions/16135814/check-for-ie-10?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
  // IF THE BROWSER IS INTERNET EXPLORER 10
  if (navigator.appVersion.indexOf("MSIE 10") !== -1)
  {
    return true
  }
  else{
    return false
  }
}

function testIsIE11 () {
  // From https://stackoverflow.com/questions/16135814/check-for-ie-10?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
  // IF THE BROWSER IS INTERNET EXPLORER 11
  var UAString = navigator.userAgent;
  if (UAString.indexOf("Trident") !== -1 && UAString.indexOf("rv:11") !== -1)
  {
    return true
  }
  else
  {
    return false
  }
}

